import React, { useRef, useState } from "react";
import { api, imgURL } from "../lib/api";
import { toast } from "sonner";
import { Upload, Trash2, Loader2, ImageIcon } from "lucide-react";

export function ImageUpload({ value, onChange, label = "Slika", hint }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const onFile = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (!f.type.startsWith("image/")) { toast.error("Izaberite sliku"); return; }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Slika otpremljena");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Otpremanje nije uspelo");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const confirmRemove = () => {
    onChange("");
    setConfirmOpen(false);
    toast.success("Slika uklonjena");
  };

  return (
    <div className="mb-3">
      <span className="text-xs font-semibold text-slate-500 uppercase tracking-wide">{label}</span>
      {hint && <p className="text-[11px] text-slate-400 mt-0.5" data-testid="image-upload-hint">{hint}</p>}
      <div className="mt-1 flex items-center gap-3">
        <div className="w-16 h-16 rounded-lg overflow-hidden bg-slate-100 flex items-center justify-center flex-shrink-0">
          {value ? <img src={imgURL(value)} alt="" className="w-full h-full object-cover" /> : <ImageIcon size={18} className="text-slate-300" />}
        </div>
        <button type="button" data-testid="upload-image-btn" onClick={() => inputRef.current?.click()} disabled={busy}
          className="px-3 py-2 rounded-lg bg-slate-800 text-white text-sm font-semibold flex items-center gap-1 disabled:opacity-50">
          {busy ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />}{value ? "Zameni" : "Otpremi"}
        </button>
        {value && (
          <button type="button" data-testid="remove-image-btn" onClick={() => setConfirmOpen(true)}
            className="px-3 py-2 rounded-lg bg-brand-red/10 text-brand-red text-sm font-semibold flex items-center gap-1">
            <Trash2 size={14} />Ukloni
          </button>
        )}
        <input ref={inputRef} type="file" accept="image/*" onChange={onFile} className="hidden" data-testid="image-file-input" />
      </div>

      {confirmOpen && (
        <div className="fixed inset-0 z-[80] flex items-center justify-center p-4" data-testid="remove-image-confirm">
          <div className="absolute inset-0 bg-black/50" onClick={() => setConfirmOpen(false)} />
          <div className="relative bg-white rounded-2xl p-6 w-full max-w-sm">
            <h3 className="font-display font-black text-lg">Da li ste sigurni da želite da uklonite sliku?</h3>
            <div className="grid grid-cols-2 gap-2 mt-5">
              <button type="button" data-testid="cancel-remove-image" onClick={() => setConfirmOpen(false)}
                className="rounded-lg py-2.5 bg-slate-100 font-semibold">Otkaži</button>
              <button type="button" data-testid="confirm-remove-image" onClick={confirmRemove}
                className="rounded-lg py-2.5 bg-brand-red text-white font-bold flex items-center justify-center gap-1">
                <Trash2 size={15} /> Ukloni sliku
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
